
export class SimpleSignal
{
	private _listeners:Function[];
	private _scopes:any[];

	constructor()
	{
		this._listeners = [];
		this._scopes = [];
	}

	public add(listener:Function, scope?:any)
	{
		if (this._listeners.indexOf(listener) === -1)
		{
			this._listeners.push(listener);
			if (scope)
			{
				this._scopes[this._listeners.length-1] = scope;
			}
		}
	}

	public remove(listener)
	{
		var index = this._listeners.indexOf(listener);
		if (index > -1)
		{
			this._listeners.splice(index, 1);
			if (this._scopes[index])
			{
				this._scopes.splice(index, 1);
			}
		}
	}

	public dispatch(...p: any[])
	{
		var listeners = this._listeners.slice(0);
		for (var i = 0, ln = listeners.length; i < ln; i++)
		{
			var scope = this._scopes[i] || this;
			listeners[i].apply(scope, arguments);
		}
	}

	public get listeners()
	{
		return this._listeners;
	}
}